import PortfolioItem from "../../../components/portfolio/portfolio-item";
import PortfolioDatas from "../../../data/portfolioTrailer.json";
import useMasonry from "../../../hooks/use-masonry";
import { slugify } from "../../../utils";
import { Link } from "react-router-dom";
import React from "react";

const PortfolioContainer = () => {
    // Isotope Categories list JS

    const { categories } = useMasonry(
        PortfolioDatas,
        ".portfolio-list",
        ".masonry-grid",
        ".messonry-button",
        ".messonry-button button"
    );
    return (
        <div className="portfolio-area portfolio-default-area">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="messonry-button text-center mb-50"></div>
                    </div>
                </div>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 portfolio-list mb-n30">
                    {PortfolioDatas &&
                        PortfolioDatas.map((portfolio) => (
                            <div
                                key={portfolio.id}
                                className={`col masonry-grid mb-30 ${portfolio.categories
                                    .map((cat) => slugify(cat))
                                    .join(" ")}`}
                            >
                                <PortfolioItem portfolio={portfolio} />
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default PortfolioContainer;
